import { Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UiformBaseComponent } from '../uiform/uiform-base/uiform-base.component';
import { DatePipe } from '@angular/common';

declare var require: any;
const Plotly = require('plotly.js-dist-min');

@Component({
  selector: 'app-view-report',
  templateUrl: './view-report.component.html',
  styleUrls: ['./view-report.component.scss'],
})
export class ViewReportComponent extends UiformBaseComponent {
  @ViewChild('content')
  content!: ElementRef;
  public sanitizedData: any = [];
  public reportData: any = {};
  public reportTitle: any = '';
  public searchReport: any;
  public loading: boolean = false;
  dropdownOpen: boolean = false;
  public selectedSearchAtt: any;
  searchData: any = {};
  searchView: any = {};
  svgdata: any;
  @Input() reportId: any;

  @ViewChild('chartIframe') chartIframe!: ElementRef;

  public reqform: any = {
    chart_type: 'html',
    margins: false,
  };
  public pivotform: any = {
    chart_type: 'html',
  };

  selectedFieldObject: any;

  private sanitizer = inject(DomSanitizer);
  pivotUrl: SafeResourceUrl | null = null;
  pivottable: any = '<div><div>';
  chartUrl: any = null;
  chartHtml: any = null;

  @Input() uiformid: any;
  @Input() titlereport: any;
  @Input() searchdata: any;
  @Input() flag: any;
  @Input() searchList: any;
  @Input() uiFormData: any;
  @Input() autoUpdateReport: any;

  showEditButton: any = false;

  override ngOnInit() {
    let _self = this;

    _self.getDetails(
      _self.flag,
      _self.searchdata,
      _self.titlereport,
      _self.uiformid,
    );
    _self.preload();
  }

  /**
   * Reset search from
   */
  override resetSearchForm() {
    this.form.searchError = false;
    this.form.searchMessage = '';
    this.form.searchParams = {};
  }

  override preload() {
    var _self = this;
    _self.form.error = false;
    _self.form.message = '';
    this.locator.config
      .getProperty('endpoint.reports')
      .then((property: any) => {
        this.locator.http.get(_self.api.preload, (res: any, error: any) => {
          if (error) {
            return;
          }
          _self.form.error = !res.success;
          _self.form.message = res.result.message;
          if (res.success) {
            _self.form.preload = res.result;
            // Set a 2-second delay to call clearMessage
            setTimeout(() => {
              this.clearMessage(_self.form);
            }, 2000);
          }
        });
      });
  }

  /**
   * Main function to get Pivot GUI
   * @param flag
   */
  async searchAndDraw(flag: boolean, searchdata: any, title: any) {
    this.showEditButton = true;
    let _self = this;
    _self.reportTitle = title;
    _self.reqform = searchdata;
    if (flag) {
      this.searchCriteria(() => {
        _self.cleanData();
        _self.findNumericFields();
        _self.getPivotGui();
      });
    } else {
      _self.getPivotGui();
    }
  }

  /**
   * Remove common attributes from searched result data
   */
  public cleanData(): any {
    let _self = this;
    const allowedKeysMap = _self.filterAttributes.reduce(
      (map: any, attr: any) => {
        if (attr['code'] && attr['label']) {
          map[attr['code']] = attr['label'];
        }
        return map;
      },
      {},
    );

    _self.sanitizedData = _self.usecaseData.map((item: any) => {
      const sanitizedItem: any = {};
      Object.keys(allowedKeysMap).forEach((key: string) => {
        if (key in item) {
          sanitizedItem[allowedKeysMap[key]] = item[key];
        }
      });
      return sanitizedItem;
    });
  }

  /**
   * Create Pivot GUI from server side
   */

  getPivotGui() {
    let _self = this;
    _self.loading = true;
    _self.reportData = {};
    _self.form['error'] = false;
    _self.form['message'] = '';
    _self.pivottable = '';
    _self.pivotUrl = null;
    _self.chartUrl = null;
    _self.chartHtml = null;
    _self.reqform['title'] = _self.usecase['name'];
    _self.reqform['values'] = this.reqform['aggfunc']
      ? Object.keys(this.reqform['aggfunc'])
      : [];
    _self.reqform['numericfields'] = _self.findNumericFields();
    _self.reportData = _self.reqform;

    // if (
    //   _self.reqform &&
    //   (_self.reqform['index'] != null || _self.reqform['columns'] != null)
    // ) {

      _self.locator.config
        .getProperty('endpoint.pivot')
        .then((property: string) => {
          let url = _self.urlRewrite(property);
            _self.reqform['data'] = _self.sanitizedData;

          let client = _self.locator.http.getClient();
          client.post(url, _self.reqform, { responseType: 'text' }).subscribe(
            (data: any) => {
              try {
                const jsonResponse = JSON.parse(data);
                if (!jsonResponse['success']) {
                  _self.form['error'] = true;
                  _self.form['message'] = jsonResponse['message'];
                  _self.loading = false;
                  return;
                }
              }
              // catch (error) {
              //   // ✅ HTML chart aaya
              //   _self.chartHtml = data;
              //   _self.pivottable = '';

              //   // 🔥 IMPORTANT: convert HTML → iframe URL
              //   const blob = new Blob([data], { type: 'text/html' });
              //   const url = URL.createObjectURL(blob);

              //   _self.chartUrl =
              //     this.sanitizer.bypassSecurityTrustResourceUrl(url);
              // }
              catch (error) {

                // 🔥 Detect: Chart ya Table
                if (data.includes('Plotly.newPlot') || data.includes('plotly')) {

                  // ✅ Chart case
                  _self.chartHtml = data;
                  _self.pivottable = '';

                  const blob = new Blob([data], { type: 'text/html' });
                  const url = URL.createObjectURL(blob);

                  _self.chartUrl =
                    this.sanitizer.bypassSecurityTrustResourceUrl(url);

          } else {

                  // ✅ Table case
                  _self.pivottable = data;
                  _self.chartUrl = null;
                    }
              }

              _self.loading = false;
            },
            (error: any) => {
              _self.form['error'] = true;
              _self.form['message'] = 'Error loading pivot table';
              _self.loading = false;
              console.error('Error:', error);
            }
          );
        });
    }

  /**
   * Function to find all numeric fields
   * @returns
   */
  findNumericFields = () => {
    const numericFields = new Set();
    this.sanitizedData.forEach((item: any) => {
      Object.keys(item).forEach((key) => {
        if (typeof item[key] === 'number') {
          numericFields.add(key);
        }
      });
    });
    return Array.from(numericFields);
  };

  /**
   * Reset search values
   */
  resetSearchValues() {
    this.searchValues = {};
    this.searchAndDrawnew(true);
  }

  /**
   * Update form field
   * @param field
   * @param value
   * @param aggValue
   * @param isKey
   */
  updateFormField(
    field: string,
    value: any,
    aggValue?: any,
    isKey: boolean = false,
  ) {
    this.reqform[field] = this.reqform[field] || (isKey ? {} : []);
    if (isKey) {
      aggValue = aggValue?.trim() || 'sum';
      this.reqform[field][value] = aggValue;
    } else {
      this.reqform[field].push(value);
    }
  }

  /**
   * Remove form field
   * @param field
   * @param value
   * @param isKey
   */
  removeFormField(field: string, value: any, isKey: boolean = false) {
    if (isKey) {
      delete this.reqform[field]?.[value];
    } else if (Array.isArray(this.reqform[field])) {
      const index = this.reqform[field].indexOf(value);
      if (index > -1) this.reqform[field].splice(index, 1);
    }
  }

  /**
   * Search and draw pivot data
   * @param flag
   * @param searchdata
   * @param title
   * @param uiformId
   */
  async getDetails(flag: boolean, searchdata: any, title: any, uiformId: any) {
    let _self = this;
    _self.is_paging = false;

    if (uiformId) {
      try {
        const endpoint =
          await _self.locator.config.getProperty('endpoint.ui.forms');

        await new Promise<void>((resolve) => {
          _self.get(uiformId, async function () {
            _self.usecaseId = _self.form.data.userstoryId;

            await _self.getUsecaseSchema(false, async () => {
              _self.filterAttributes = await _self.getFilterAttributes(
                _self.usecaseAttributes,
                _self.form.data['fields'],
              );
              resolve();
            });
          });
        });

        // Call searchAndDraw only after all operations are complete
        _self.searchAndDraw(flag, searchdata, title);
      } catch (error) {
        console.error('Error in getDetails:', error);
      }
    }
  }

  /**
   * Draw pivot data
   * @param flag
   */
  searchAndDrawnew(flag: boolean) {
    let _self = this;
    if (flag) {
      this.searchCriteria(() => {
        _self.cleanData();
        _self.findNumericFields;
        _self.getPivotGui();
      });
    } else {
      _self.getPivotGui();
    }
  }

  /**
   * search for parent usecase dependency
   * @param e
   * @param value
   */
  override onSearchReferenceValueChange(e: any, value: any) {
    this.searchValues[e.code] =
      e.type === 'number' ? parseFloat(value.target.value) : value.target.value;
    let _self = this;
    if (
      _self.usecase !== undefined &&
      _self.usecase['parentUsecaseDependency'] !== undefined &&
      _self.usecase['parentUsecaseDependency'][e['primaryUsecase']] !==
        undefined
    ) {
      _self.primaryUsecaseDependencyFilter(
        _self.usecase['parentUsecaseDependency'][e['primaryUsecase']],
        value,
      );
    }
  }

  /***
   * primaryUsecaseDependencyFilter
   */
  primaryUsecaseDependencyFilter(data: any, val: any) {
    let _self = this;
    let key = val['target']['id'];
    let [appCode, codes] = (data['code'] ?? '').toString().split('.');
    let url =
      _self.locator.config.get('endpoint.api.v1') +
      '/' +
      appCode +
      '/' +
      codes +
      '/preloadData';
    let searchParams = {
      [key]: parseFloat(val['target']['value']),
    };
    _self.locator.http.post(
      url,
      searchParams,
      function (res: any, error: boolean) {
        if (error) {
          return;
        }
        _self.form.preload[data['code']] = res.result[data['code']];
      },
    );
  }

  /**
   * add search data
   */
  // addSearchData() {
  //   let _self = this;

  //   if (!_self.searchData['field']) {
  //     alert('Field is empty');
  //     return;
  //   } else if (!_self.searchData['condition']) {
  //     alert('Condition is empty');
  //     return;
  //   } else if (!_self.searchData['value']) {
  //     alert('Value is empty');
  //     return;
  //   } else {
  //     const normalizedNumericFields = _self
  //       .findNumericFields()
  //       .map((label: any) => label.toLowerCase().replace(/\s+/g, ''));
  //     const normalizedField = _self.searchData.field
  //       .toLowerCase()
  //       .replace(/\s+/g, '');
  //     if (normalizedNumericFields.includes(normalizedField)) {
  //       const numValue = Number(_self.searchData.value);
  //       if (!isNaN(numValue)) {
  //         _self.searchData.value = numValue;
  //       }
  //     }
  //     _self.searchList.push(_self.searchData);
  //     _self.searchData = {};
  //   }
  //   this.searchView['field'] = '';
  // }

  addSearchData() {
    let _self = this;

    // Date validation and today/yesterday detection
    if (
      _self.selectedSearchAtt === 'date' &&
      _self.searchData['condition'] !== 'BETWEEN'
    ) {
      if (
        _self.searchData['condition'] !== 'DAY' &&
        _self.searchData['condition'] !== 'MONTH' &&
        _self.searchData['condition'] !== 'DAY_AND_MONTH' &&
        ['NULL', 'NOT NULL', 'EMPTY'].indexOf(_self.searchData['condition']) ===
          -1
      ) {
        if (!_self.searchData['value']) {
          alert('Date is empty');
          return;
        } else {
          const searchDate = new Date(_self.searchData['value']);
          const currentDate = new Date();
          const yesterDate = new Date();

          searchDate.setHours(0, 0, 0, 0);
          currentDate.setHours(0, 0, 0, 0);
          yesterDate.setDate(currentDate.getDate() - 1);
          yesterDate.setHours(0, 0, 0, 0);

          if (searchDate.getTime() === currentDate.getTime()) {
            _self.searchData['date'] = 'today';
          } else if (searchDate.getTime() === yesterDate.getTime()) {
            _self.searchData['date'] = 'yesterday';
          } else {
            console.log('The date is neither today nor yesterday.');
          }
        }
      }
    }

    // Parse rangeDate from ngxDaterangepickerMd
    if (_self.searchData['rangeDate']) {
      _self.searchData['rangeFrom'] =
        _self.searchData.rangeDate.startDate.format('YYYY-MM-DD');
      _self.searchData['rangeTo'] =
        _self.searchData.rangeDate.endDate.format('YYYY-MM-DD');
    }

    // Field validation
    if (!_self.searchData['field']) {
      alert('Field is empty');
      return;

      // Condition validation
    } else if (!_self.searchData['condition']) {
      alert('Condition is empty');
      return;

      // BETWEEN handling
    } else if (_self.searchData['condition'] === 'BETWEEN') {
      if (!_self.searchData['rangeFrom']) {
        alert('From value is empty');
        return;
      }

      if (!_self.searchData['rangeTo']) {
        alert('To value is empty');
        return;
      }

      // ✅ Create copy for API (DO NOT MODIFY ORIGINAL OBJECT)
      let payload = {
        ..._self.searchData,
        value: undefined,
      };

      // ✅ Push correct payload (for backend)
      _self.searchList.push(payload);

      // ✅ Add label for UI (IMPORTANT for your chip display)
      _self.operators.forEach((e: any) => {
        if (_self.searchData['condition'] === e.value) {
          payload['label'] = _self.searchData['field']; // for UI
          payload['conditionLabel'] = e.label; // optional
        }
      });

      // Reset
      _self.searchData = {};
      _self.searchView['field'] = '';
      _self.selectedSearchAtt = undefined;
    } else {
      // Skip value check for NULL / NOT NULL / EMPTY
      if (
        ['NULL', 'NOT NULL', 'EMPTY'].indexOf(_self.searchData['condition']) ===
          -1 &&
        !_self.searchData['value']
      ) {
      alert('Value is empty');
      return;
      }

      // EMPTY condition for number field → set value to 0
      if (
        _self.searchData['condition'] === 'EMPTY' &&
        _self.selectedSearchAtt === 'number'
      ) {
        _self.searchData['value'] = 0;
      }

      // Numeric field type coercion (your report-view logic)
      const normalizedNumericFields = _self
        .findNumericFields()
        .map((label: any) => label.toLowerCase().replace(/\s+/g, ''));
      const normalizedField = _self.searchData.field
        .toLowerCase()
        .replace(/\s+/g, '');

      if (normalizedNumericFields.includes(normalizedField)) {
        const numValue = Number(_self.searchData.value);
        if (!isNaN(numValue)) {
          _self.searchData.value = numValue;
        }
      }

      // Push to searchList
      _self.searchList.push(_self.searchData);

      // Reset
      _self.searchData = {};
      _self.searchView['field'] = '';
      _self.selectedSearchAtt = undefined;
    }
  }

  /**
   * Reset search data
   * @param index
   */
  removeSearchData(index: any) {
    if (index > -1) this.searchList.splice(index, 1);
  }

  /**
   * Reset search criteria
   */
  resetSearchCriteria() {
    this.searchList = [];
    this.searchData = {};
    this.searchView = {};
  }

  /**
   * Search criteria
   * @param callback
   */
  searchCriteria(callback?: any) {
    let _self = this;

    const datePipe = new DatePipe('en-US');
    _self.searchList.forEach((e: any) => {
      const currentDate = new Date();
      if (e?.date === 'today') {
        console.log('today');

        e['value'] = datePipe.transform(currentDate, 'yyyy-MM-dd');
      } else if (e?.date === 'yesterday') {
        console.log('yesterday');
        const yesterday = new Date(currentDate.getTime() - 1);
        e['value'] = datePipe.transform(yesterday, 'yyyy-MM-dd');
      }
    });
    let searchCriteria = {
      searchList: _self.searchList,
    };

    let url = _self.apiurl + '/searchCriteria';

    this.locator.http.post(
      url,
      searchCriteria,
      function (res: any, error: any) {
        if (error) {
          if (callback) {
            callback(error);
          }

          return;
        }

        if (res.success) {
          _self.usecaseData = res.result['data'];
          // Add data in Datatable
          //_self.initializeDataTable();

          if (callback) {
            callback();
          }
        }

        if (callback) {
          callback();
        }
        _self.processData();
      },
    );
  }

  /**
   * Button labels for pivot table
   * @param type
   * @returns
   */
  // getButtonLabels(type: string): string {
  //   const typeMap: { [key: string]: string } = {
  //     text: 'T',
  //     number: 'N',
  //     long: 'N',
  //     date: 'D',
  //     decimal: 'N',
  //     doc: 'T',
  //     email: 'E',
  //     expression: 'N',
  //     file: 'I',
  //     list: 'C',
  //     map: 'C',
  //     object: 'O',
  //     password: 'P',
  //     phone: 'T',
  //     textarea: 'T',
  //     url: 'T',
  //   };
  //   return typeMap[type]; // Default '?' if type is unknown
  // }

  getButtonLabels(type: string): string {
    const typeMap: { [key: string]: string } = {
      text: 'T',
      number: 'N',
      long: 'N',
      date: 'D',
      decimal: 'N',
      doc: 'Doc',
      email: 'E',
      expression: 'Exp',
      file: 'F',
      list: 'L',
      map: 'C',
      object: 'O',
      password: 'Pwd',
      phone: 'Phn',
      textarea: 'TA',
      url: 'Url',
    };

    // Convert to lowercase for case-insensitive matching
    const normalizedType = (type || '').toLowerCase();
    return (
      typeMap[normalizedType] ||
      (normalizedType ? normalizedType.charAt(0).toUpperCase() : '?')
    );
  }
  /**
   * Button class for pivot table
   * @param type
   * @returns
   */
  // getButtonClass(type: string): string {
  //   const typeClassMap: { [key: string]: string } = {
  //     text: 'text-bg-success', // Green for text
  //     number: 'text-bg-primary', // Blue for number
  //     date: 'text-bg-warning',
  //     long: 'text-bg-primary',
  //     decimal: 'text-bg-primary',
  //     doc: 'T',
  //     email: 'text-bg-success',
  //     expression: 'text-bg-primary',
  //     file: 'I',
  //     list: 'L',
  //     map: 'M',
  //     object: 'O',
  //     password: 'P',
  //     phone: 'T',
  //     textarea: 'T',
  //     url: 'U',
  //   };
  //   return typeClassMap[type] || 'text-bg-success'; // Default grey
  // }

  getButtonClass(type: string): string {
    const typeClassMap: { [key: string]: string } = {
      text: 'text-bg-success',
      number: 'text-bg-primary',
      date: 'text-bg-warning',
      long: 'text-bg-primary',
      decimal: 'text-bg-primary',
      doc: 'text-bg-info',
      email: 'text-bg-success', // Email gets green
      expression: 'text-bg-info',
      file: 'text-bg-secondary',
      list: 'text-bg-danger', // List gets red
      map: 'text-bg-dark', // Map gets dark
      object: 'text-bg-secondary',
      password: 'text-bg-warning',
      phone: 'text-bg-success',
      textarea: 'text-bg-success',
      url: 'text-bg-info',
      // Add new mappings
      keyvalue: 'text-bg-info',
      image: 'text-bg-info',
    };

    const normalizedType = (type || '').toLowerCase();
    return typeClassMap[normalizedType] || 'text-bg-secondary';
  }

  /**
   * Toggle dropdown
   */
  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  /**
   * Select column value set
   * @param value
   * @param key
   */
  selectColumn(value: string, key: string) {
    this.pivotform[key] = value;
  }

  /**
   * Select search value set
   * @param value
   * @param key
   */
  selectSearch(value: any, key: string) {
    this.searchData[key] = value['code'];
    this.searchData['label'] = value['label'];
    this.searchView[key] = value['label'];
    if (key === 'field') {
      this.getType(this.searchData['field']);
    }
  }

  /**
   * Get type of value
   * @param value
   */
  getType(value: any) {
    let _self = this;
    _self.filterAttributes.forEach((e: any) => {
      if (e.code === value) {
        this.searchData['value'] = '';
        _self.selectedSearchAtt = e?.type;
      }
    });
  }

  /**
   * Filter type operators
   */
  operators = [
    { label: '=', value: 'EQ' },
    { label: '!=', value: 'NEQ' },
    { label: '>', value: 'GT' },
    { label: '<', value: 'LT' },
    { label: '>=', value: 'GTE' },
    { label: '<=', value: 'LTE' },
    { label: 'like', value: 'LIKE' },
    { label: 'between', value: 'BETWEEN' },
    { label: 'Not Null', value: 'NOT NULL' },
    { label: 'Null', value: 'NULL' },
    { label: 'Empty', value: 'EMPTY' },
    { label: 'Day', value: 'DAY' },
    { label: 'Month', value: 'MONTH' },
    { label: 'Day & Month', value: 'DAY_AND_MONTH' },
  ];

  /**
   * Export data in PDF
   */
  /**
   * Export data in PDF with improved wide table handling
   */

  // public exportPDFData(): void {
  //   const _self = this;
  //   if (!_self.pivottable || Object.keys(_self.pivottable).length === 0) {
  //     if (this.svgdata) {
  //       const reader = new FileReader();
  //       reader.onload = () => {
  //         let svgText = reader.result as string;

  //         // _self.pivottable = svgText;
  //         // ✅ remove matplotlib metadata text
  //         svgText = svgText
  //           .replace(/image\/svg\+xml[\s\S]*?matplotlib\.org\/?/gi, '')
  //           .replace(/<metadata[\s\S]*?<\/metadata>/gi, '');

  //         // ✅ enforce SVG size so it fits A4 landscape
  //         svgText = svgText.replace(
  //           /<svg([^>]*)>/i,
  //           `<svg$1 width="100%" height="600" viewBox="0 0 1200 600" preserveAspectRatio="xMidYMid meet">`,
  //         );

  //         // ✅ THIS is the only assignment you need
  //         _self.pivottable = svgText;

  //         console.log('Hello world : ');

  //         _self.sendPDFRequest();
  //       };
  //       reader.readAsText(this.svgdata);
  //       return;
  //     } else {
  //       _self.sendPDFRequest();
  //     }
  //   } else {
  //     _self.sendPDFRequest();
  //   }
  // }


  public async exportPDFData(): Promise<void> {
    const _self = this;

    if (this.chartUrl) {
      try {
        await this.waitForIframeLoad();

        const iframe = this.chartIframe.nativeElement;
        const iframeWin = iframe.contentWindow;
        const Plotly = (iframeWin as any)?.Plotly;

        if (Plotly) {
          let chartDiv = iframeWin?.document?.getElementById('plotly-chart');
          if (!chartDiv) {
            chartDiv = iframeWin?.document?.querySelector('.plotly-graph-div');
          }

          if (chartDiv) {
            const svgUrl = await Plotly.toImage(chartDiv, {
              format: 'svg',
              width: 750,
              height: 450,
              scale: 1
            });

            // ✅ FIX: Properly extract SVG from data URL
            let svgText = '';

            // Remove the data:image/svg+xml prefix
            if (svgUrl.startsWith('data:image/svg+xml')) {
              // Get everything after the comma
              const commaIndex = svgUrl.indexOf(',');
              if (commaIndex !== -1) {
                const encodedSvg = svgUrl.substring(commaIndex + 1);
                // Decode the URI component
                svgText = decodeURIComponent(encodedSvg);
              }
            } else {
              svgText = svgUrl;
            }

            // ✅ Clean up metadata
          svgText = svgText
              .replace(/<\?xml[^>]*\?>/g, '')  // Remove XML declaration
              .replace(/<!--[\s\S]*?-->/g, '')  // Remove comments
            .replace(/image\/svg\+xml[\s\S]*?matplotlib\.org\/?/gi, '')
            .replace(/<metadata[\s\S]*?<\/metadata>/gi, '');

            // ✅ Fix SVG attributes
          svgText = svgText.replace(
            /<svg([^>]*)>/i,
              `<svg$1 width="100%" height="auto" viewBox="0 0 750 450" preserveAspectRatio="xMidYMid meet">`
          );

            // ✅ Final cleanup - remove any remaining data:image/svg+xml text
            svgText = svgText.replace(/data:image\/svg\+xml,?/gi, '');

          _self.pivottable = svgText;
            console.log('Chart converted successfully!');
      }
    }
      } catch (error) {
        // console.error('Chart conversion failed:', error);
        // _self.pivottable = '<div style="padding:20px;text-align:center;">Chart could not be loaded</div>';
      }
    }

          _self.sendPDFRequest();
  }


  public sendPDFRequest() {
    let _self = this;

    this.locator.config
      .getProperty('endpoint.api.v1')
      .then((property: string) => {
        const keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
        let sid = localStorage.getItem(keySuffix + 'sessionId');
        if (!sid) {
          sid = '0';
        }
        const url = `${property}/${this.appId}/${this.uiformId}/reportPdf;jsessionid=${sid}`;

        // Prepare HTML content for PDF generation
        const tableStyle = `
        <style>
          @page {
            size: A4 landscape;
            margin: 5mm;
          }
          body {
            margin: 0;
            padding: 0;
          }
          table {
            border-collapse: collapse;
            width: 100%;
            table-layout: fixed;
            page-break-inside: auto;
            font-family: 'NotoSerifGujarati', sans-serif;
          }
          th, td {
            border: 1px solid #ddd;
            padding: 3px;
            font-size: 7px;
            word-wrap: break-word;
            overflow-wrap: break-word;
            text-align: center;
          }
          th {
            background-color: #f2f2f2;
            font-weight: bold;
          }
          tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }
        </style>
      `;

        const htmlContent = `
        <html>
          <head>${tableStyle}</head>
          <body>
            <div style="width: 100%; overflow: hidden;">
              ${_self.pivottable}
            </div>
          </body>
        </html>
      `;

        // Send the HTML content to the backend to generate PDF
        _self.locator.http
          .getClient()
          .post(url, { html: htmlContent }, { responseType: 'blob' })
          .subscribe(
            (data: any) => {
              _self.downloadDataAsFile(data, 'export.pdf');
            },
            (error: any) => {
              alert(
                'Failed to generate PDF. Please try again or contact support.',
              );
            },
          );
      });
  }

  /**
   * Downalod data as file
   * @param data
   * @param fileName
   */
  public downloadDataAsFile(data: any, fileName: string) {
    //Create a dynamic link and download file
    let file = new window.Blob([data], { type: 'application/pdf' });
    const downloadAncher = document.createElement('a');
    downloadAncher.style.display = 'none';
    const fileURL = URL.createObjectURL(file);
    downloadAncher.href = fileURL;
    downloadAncher.download = fileName;
    downloadAncher.click();
  }


  // ✅ YEH FUNCTION ADD KARO (NEEECHE)
  private waitForIframeLoad(): Promise<void> {
    return new Promise((resolve) => {
      const iframe = this.chartIframe?.nativeElement;
      if (!iframe) {
        resolve();
        return;
      }

      if (iframe.contentDocument && iframe.contentDocument.readyState === 'complete') {
        resolve();
      } else {
        iframe.addEventListener('load', () => resolve());
      }
    });
  }

  /**
   * Handle field label selection
   * @param label
   */
  onFieldLabelSelected(label: string): void {
    // Find the object by label
    const fieldObj = this.filterAttributes.find((e: any) => e.label === label);
    if (fieldObj) {
      // Call your existing selectSearch method with the full object
      this.selectSearch(fieldObj, 'field');
    }
  }

  // Component mein
  selectedDay: string = 'Today';
  selectedMonth: string = 'CURRENT';

  days = [
    'Today',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '30',
    '31',
  ];

  months = [
    { value: 'CURRENT', name: 'Current Month' },
    { value: '01', name: 'January' },
    { value: '02', name: 'February' },
    { value: '03', name: 'March' },
    { value: '04', name: 'April' },
    { value: '05', name: 'May' },
    { value: '06', name: 'June' },
    { value: '07', name: 'July' },
    { value: '08', name: 'August' },
    { value: '09', name: 'September' },
    { value: '10', name: 'October' },
    { value: '11', name: 'November' },
    { value: '12', name: 'December' },
  ];

  selectDay(day: string) {
    this.selectedDay = day;
    this.dayDropdownOpen = false;
    this.onDayChange(); // <-- 🔥 your logic still works
  }

  onDayChange() {
    if (this.selectedDay) {
      const date = new Date();
      const currentYear = date.getFullYear();
      const currentMonth = String(date.getMonth() + 1).padStart(2, '0');

      let day = this.selectedDay;

      // FIX ONLY FOR "today"
      if (this.selectedDay === 'Today') {
        day = String(date.getDate()).padStart(2, '0');
      }

      // this.searchData[
      //   'value'
      // ] = `${currentYear}-${currentMonth}-${this.selectedDay}`;

      this.searchData['value'] = `${currentYear}-${currentMonth}-${day}`;
    }
  }

  monthDropdownOpen = false;

  toggleMonthDropdown() {
    this.monthDropdownOpen = !this.monthDropdownOpen;
  }

  selectMonthForDayMonth(month: any) {
    this.selectedMonth = month.value;
    this.monthDropdownOpen = false;
    this.onDayMonthChange();
  }

  getMonthName(value: string) {
    return this.months.find((m) => m.value === value)?.name;
  }

  onDayMonthChange() {
    if (this.selectedDay && this.selectedMonth) {
      const date = new Date();
      // Current year + selected month + selected day (e.g., "2024-07-15")
      const currentYear = new Date().getFullYear();

      let month = this.selectedMonth;
      let day = this.selectedDay;

      console.log('month : ', month);

      // FIX ONLY FOR "THIS MONTH"
      if (this.selectedMonth === 'CURRENT') {
        month = String(date.getMonth() + 1).padStart(2, '0');
        console.log(month);
      }

      //  FIX ONLY FOR "today"
      if (this.selectedDay === 'Today') {
        day = String(date.getDate()).padStart(2, '0');
      }

      //  this.searchData[
      //    'value'
      //  ] = `${currentYear}-${this.selectedMonth}-${this.selectedDay}`;

      this.searchData['value'] = `${currentYear}-${month}-${day}`;
    }
  }

  onMonthChange() {
    if (this.selectedMonth) {
      const date = new Date();
      const currentYear = date.getFullYear();
      const currentDay = String(date.getDate()).padStart(2, '0');

      //  const month = String(this.selectedMonth).padStart(2, '0');

      let month = this.selectedMonth;

      console.log('month : ', month);

      //  FIX ONLY FOR "THIS MONTH"
      if (this.selectedMonth === 'CURRENT') {
        month = String(date.getMonth() + 1).padStart(2, '0');
        console.log(month);
      }

      // this.searchData[
      //   'value'
      // ] = `${currentYear}-${this.selectedMonth}-${currentDay}`;

      this.searchData['value'] = `${currentYear}-${month}-${currentDay}`;
    }
  }

  selectMonth(month: any) {
    this.selectedMonth = month.value;
    this.monthDropdownOpen = false;
    this.onMonthChange();
  }

  selectDayForDayMonth(day: string) {
    this.selectedDay = day;
    this.dayDropdownOpen = false;
    this.onDayMonthChange();
  }

  dayDropdownOpen = false;

  toggleDayDropdown() {
    this.dayDropdownOpen = !this.dayDropdownOpen;
  }

  ranges: any = {
    Today: [new Date(), new Date()],
    Yesterday: [
      new Date(new Date().setDate(new Date().getDate() - 1)),
      new Date(new Date().setDate(new Date().getDate() - 1)),
    ],
    'This Week': [
      new Date(new Date().setDate(new Date().getDate() - new Date().getDay())),
      new Date(
        new Date().setDate(new Date().getDate() + (6 - new Date().getDay())),
      ),
    ],
    'Last Week': [
      new Date(
        new Date().setDate(new Date().getDate() - new Date().getDay() - 7),
      ),
      new Date(
        new Date().setDate(new Date().getDate() - new Date().getDay() - 1),
      ),
    ],
    'This Month': [
      new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    ],
    'Last Month': [
      new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
      new Date(new Date().getFullYear(), new Date().getMonth(), 0),
    ],
  };
}
